// Copyright (c) 2020 Deere & Company

import openPartRequests from './open-part-requests';
import specialAllowanceClaimStatus from './special-allowance-claim-status';

export default {
    childRoutes: [
        openPartRequests,
        specialAllowanceClaimStatus
    ]
};



// WEBPACK FOOTER //
// ./src/routes/tabm/reports/index.js